import type { OnboardingChecklistStep } from '../shared/types';
import { PRICE_LIST_STEP } from './steps/price-list/checklist-item';
import { PRICE_LIST_ASSIGNMENT_STEP } from './steps/price-list-assignment/checklist-item';

// Whole-store setup steps, shown ungated so either can be tackled first. Shared by the setup page and
// the home-page onboarding banner so both agree on what "setup done" means.
export const DEFAULT_SETUP_STEPS: OnboardingChecklistStep[] = [
  PRICE_LIST_STEP,
  PRICE_LIST_ASSIGNMENT_STEP,
];
